@if(hasActiveCampaign) {
  @if(!loading) {
    <app-card [ngClass]="{'invite-card-expand' : expandWidth}">
      <p><strong>{{ title }}</strong></p>
      <button mat-raised-button (click)="recieveClickOfferAction('InviteFriends')">{{ 'Intellitrailer.Rental.Screen.btnInvite' | translate : 'Invite' }}</button>
    </app-card>
  
    }
    @else if (loading) {
      <div class="inverted-spinner">
        <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
        <p>{{ 'Intellitrailer.Rental.ReturnComplete.LoadingReturn' | translate : 'Loading...' }}</p>
      </div>
    }
}
